/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-22 17:27:41
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-06 11:22:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAnimation/tool.ts
 */
import { errCodesMap } from '@/src/error/code';
import { cloneDeep } from 'lodash';
import {
  generateCollapseOpen,
  generateCollapseErrorMsgDisplay,
  convertSpecificError,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export enum AnimationType {
  EntranceEffect = 'EntranceEffect',
  HoverEffect = 'HoverEffect',
}

export enum AnimationEffection {
  FADE = 'FADE',
  SLIDE = 'SLIDE',
  ZOOMING = 'ZOOMING',
}

export enum fadeDirection {
  FADE_IN = 'FADE_IN',
  FADE_IN_DOWN = 'FADE_IN_DOWN',
  FADE_IN_UP = 'FADE_IN_UP',
  FADE_IN_LEFT = 'FADE_IN_LEFT',
  FADE_IN_RIGHT = 'FADE_IN_RIGHT',
}

export enum slideDirection {
  SLIDE_IN_DOWN = 'SLIDE_IN_DOWN',
  SLIDE_IN_UP = 'SLIDE_IN_UP',
  SLIDE_IN_LEFT = 'SLIDE_IN_LEFT',
  SLIDE_IN_RIGHT = 'SLIDE_IN_RIGHT',
}

export enum zoomDirection {
  ZOOM_IN = 'ZOOM_IN',
}

export enum EntranceOption {
  TOGETHER = 'TOGETHER',
  ONE_BY_ONE = 'ONE_BY_ONE',
}

export enum HoverEffect {
  OVERLAY = 'OVERLAY',
  GROW = 'GROW',
}

export const generateEntranceAnimation = () => {
  return {
    animationType: AnimationType.EntranceEffect,
    effect: AnimationEffection.FADE,
    direction: fadeDirection.FADE_IN,
    option: EntranceOption.TOGETHER,
    durationMilliseconds: 1000,
    intervalMilliseconds: 400,
  };
};

export const generateHoverAnimation = () => {
  return {
    animationType: AnimationType.HoverEffect,
    effectType: HoverEffect.GROW,
    overlayColor: '#fff',
    durationMilliseconds: 400,
  };
};

export const animationValidation = (animation) => {
  const specificError = {
    name: [],
    durationMilliseconds: [],
    intervalMilliseconds: [],
  };
  if (!animation.name) {
    specificError.name.push(errCodesMap[999978]);
  }
  if (!animation.durationMilliseconds) {
    specificError.name.push(errCodesMap[999978]);
  }
  if (
    animation.option === EntranceOption.ONE_BY_ONE &&
    !animation.intervalMilliseconds
  ) {
    specificError.name.push(errCodesMap[999978]);
  }
  return {
    hasError: convertSpecificError(specificError).length > 0,
    specificError,
    generalError: [],
  };
};

export const convertDataFromServerToRedux = (res: any) => {
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    animationList,
  } = res;

  const _isNew = !uuid;

  const list = Array.isArray(animationList)
    ? animationList.map((animation) => {
        switch (animation.effect) {
          case AnimationEffection.FADE: {
            return {
              ...animation,
              direction: animation.fadeDirection,
            };
          }
          case AnimationEffection.SLIDE: {
            return {
              ...animation,
              direction: animation.slideDirection,
            };
          }
          case AnimationEffection.ZOOMING: {
            return {
              ...animation,
              direction: animation.zoomDirection,
            };
          }
          default:
            return animation;
        }
      })
    : [];

  const ids = Array.isArray(animationList)
    ? animationList.map((v) => v.uuid).filter((v) => v)
    : [];

  const collapseOpen = generateCollapseOpen(ids);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(ids, !_isNew);

  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    modifiedDate,
    createdDate,
    uuid,
    animationList: list,
  };
};

export const convertDataFromReduxToServer = (state: any) => {
  const { animationList } = state;
  const list = Array.isArray(animationList)
    ? animationList.map((animation) => {
        switch (animation.effect) {
          case AnimationEffection.FADE: {
            const re = {
              ...animation,
              fadeDirection: animation.direction,
            };
            delete re.direction;
            if (re.isNew) {
              delete re.uuid;
            }
            delete re.isNew;
            return re;
          }
          case AnimationEffection.SLIDE: {
            const re = {
              ...animation,
              slideDirection: animation.direction,
            };
            delete re.direction;
            if (re.isNew) {
              delete re.uuid;
            }
            delete re.isNew;
            return re;
          }
          case AnimationEffection.ZOOMING: {
            const re = {
              ...animation,
              zoomDirection: animation.direction,
            };
            delete re.direction;
            if (re.isNew) {
              delete re.uuid;
            }
            delete re.isNew;
            return re;
          }
          default: {
            const item = cloneDeep(animation);
            if (item.isNew) {
              delete item.uuid;
            }
            delete item.isNew;
            return item;
          }
        }
      })
    : [];
  return {
    ...state,
    animationList: list,
  };
};
